module.exports = __webpack_public_path__ + "media/application/images/svgs/search-circle-f90bb9add47569558bdeef93311f65fd.svg";